module.exports = __webpack_public_path__ + "BrightShaw.jpg?9fbc1b84830dcebfe84989cf672a5c92";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/BrightShaw.jpg
// module id = 444
// module chunks = 0